import React from 'react'
import styles from './IconFolder.module.scss'

export default function IconFolder() {
    return <div className={styles.root} />
}
